import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Calendar } from './DatePicker';

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background-color: transparent;
  user-select: none;
`;

const StyledCalendar = styled(Calendar)`
  position: ${({ vertical }) => (vertical ? 'fixed' : 'absolute')};
  inset: ${({ vertical }) =>
    vertical ? '0' : 'calc(100% + 0.5rem) auto auto'};
  z-index: 101;
  margin-bottom: 0 !important;

  ${({ theme, vertical }) =>
    !vertical &&
    css`
      margin-top: -1px;
      border: 1px solid ${theme.colors.neutral.grey80};
      border-radius: ${theme.radius.md};
      overflow: hidden;
    `}
`;

const TimeRange = styled.div`
  grid-area: time-picker;
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;

  > * {
    width: 100%;
  }
`;

export { Backdrop, StyledCalendar, TimeRange };
